module.exports = __webpack_public_path__ + "img/sanfernando.85b02104.png";